// Profile of Nikolai Genov, Finnish. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Terveydenhuolto, biotieteet, rahoitusala',
  summary: 'Bioinformatiikan tohtori ja itse toteutukseen osallistuva tekninen vetäjä, joka yhdistää tekoälyavusteisen ohjelmistokehityksen ja analytiikan säännellyissä terveydenhuollon, biotieteiden ja rahoitusalan ympäristöissä. Asiantuntemusta LLM-/RAG-järjestelmistä, MCP-integraatiosta, kliinisestä datasta, enintään viiden vuoden pankkialan ennusteista ja automatisoidusta Excel-raportoinnista. Yhdistää R-/Python-toteutuksen tiimin koordinointiin, laadunvarmistukseen ja johtotason työpajoihin; AI Act -sertifioitu ja GCP-koulutettu.',
  imageAlt: 'Nikolai Genovin muotokuva',
  personal: {
    position: 'pAIoneer Labs GmbH:n perustajaosakas ja toimitusjohtaja, Leap Dynamics GmbH:n toimitusjohtaja',
    location: 'Berliini, Saksa',
    languages: 'Saksa ja englanti (sujuva), bulgaria (sujuva)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'AI Act -sertifiointi, GCP-koulutus (2025)',
    publications: 'Vertaisarvioituja julkaisuja lehdissä Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology ja PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Tohtoriopinnot: bioinformatiikka / teoreettinen biologia',
      institution: '',
      degree: 'Tutkinto: tohtori (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Opinnot: bioinformatiikka',
      institution: 'Freie Universität Berlin',
      degree: 'Tutkinto: M.Sc., bioinformatiikka'
    },
    {
      period: '2012',
      field: 'Opinnot: bioinformatiikka',
      institution: 'Freie Universität Berlin',
      degree: 'Tutkinto: B.Sc., bioinformatiikka'
    }
  ],
  skills: [
    {
      title: 'Ydinosaaminen',
      description: 'Tekoälyavusteinen kehitys, R/Python, LLM/RAG ja MCP, kliininen data ja bioinformatiikka, ennustaminen ja stressitestaus, Excel-raportointi, Shiny, tekninen johtaminen'
    },
    {
      title: 'Ohjelmointi ja analytiikka',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Sovellukset ja raportointi',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; automatisoitu Excel-/Word-/PDF-raportointi'
    },
    {
      title: 'Tekoäly ja integraatio',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; ihmisen tarkastama tekoälyavusteinen kehitys'
    },
    {
      title: 'Ohjelmistotekniikka',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bioinformatiikka',
      description: 'RNA-seq, mikrosirut, vaihtoehtoinen silmukointi/isoformit, geenijoukkojen rikastumisanalyysi, reitti-/verkostoanalyysi, genomin kokoaminen, elinaika-analyysi; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Kliininen data',
      description: 'EDC, CRF, edit check -tarkistukset, DMP, datan validointisuunnitelmat, UAT, SAE-täsmäytys; CDISC SDTM/ADaM, RAW-/SDTM-/ADaM-putket, QC'
    }
  ],
  positions: [
    {
      period: '2022 - huhtikuu 2024',
      title: 'Raportoinnin automatisointi, T-Systems / Euroopan keskuspankki (EKP)',
      description: [
        'R-kirjaston kehitys rahoitusaikasarjojen tilastolliseen raportointiin; FAME-logiikan migraatio R/Python-ympäristöön Reticulaten avulla ja automatisoidut Word-/PDF-tulosteet.',
        'Käsittelyputkien kehitys Excel-raporttien automaattiseen tuottamiseen; analytiikan integrointi Camundaan sekä GitLab CI/CD:n, yksikkötestien, lintingin, SonarQuben ja dokumentaation tuki.',
        'Tiiminvetäjän sijaistaminen sekä osallistuminen sprinttisuunnitteluun, tekniseen koordinointiin, laadunvarmistukseen ja toimituksiin yhteistyössä sidosryhmien kanssa.'
      ]
    },
    {
      period: 'Kesäkuu 2025 - joulukuu 2025',
      title: 'Data Science & Risk Analytics Consultant, pankkiala',
      description: [
        'Ennustemallien kehitys enintään viiden vuoden suunnitteluhorisonteille sekä stressitestien toteutus.',
        'Vanhan R-koodin uudelleenkirjoitus ja refaktorointi, neljän liiketoimintaprosessin optimointi sekä ihmisen tarkastama tekoälyavusteinen kehitys toteutuksessa ja dokumentoinnissa.',
        'R-/Shiny-analyysityönkulkujen ja Excel-raporttien automaattisen tuotannon putkien rakentaminen; liiketoiminnan vaatimusten muuntaminen analyyttisiksi toteutuksiksi.'
      ]
    },
    {
      period: 'Kesäkuu 2025 - kesäkuu 2026',
      title: 'Clinical Data Manager, lääketeollisuus / kliiniset tutkimukset',
      description: [
        'EDC-järjestelmän käyttöönotto, CRF-suunnittelu, edit check -tarkistukset, käyttäjäroolit, tiedonsiirtomäärittelyt ja UAT; koordinointi CRO-yritysten, laboratorioiden ja tutkimustiimien kanssa.',
        'DMP:iden, validointisuunnitelmien, SAE-täsmäytyssuunnitelmien ja UAT-dokumentaation laatiminen ja katselmointi; R-pohjaisten validointityönkulkujen ja Shiny-sovellusten kehitys GCP:n kannalta merkityksellisessä ympäristössä.'
      ]
    },
    {
      period: 'Heinäkuu 2026',
      title: 'Kliininen dataputki, Dr. Falk Pharma',
      description: [
        'RAW-/SDTM-/ADaM-putken rakentaminen R:llä OpenCoden ja tekoälyavusteisen kehityksen avulla; mukana validointi, QC, jäljitettävyys ja automatisoidut Excel-raporttiputket.'
      ]
    },
    {
      period: '2026',
      title: 'Tekoälyavusteinen audit trail -raportointi, Miltenyi Biotec',
      description: [
        'Audit trail -raporttien ja automatisoitujen Excel-raporttiputkien toteutus OpenCoden ja tekoälyavusteisen kehityksen avulla, mukaan lukien raportointilogiikka, virheenkorjaus, dokumentointi ja ihmisen tekemä tarkastus.'
      ]
    },
    {
      period: 'Vuodesta 2019 alkaen',
      title: 'Toimitusjohtaja ja yksi perustajista / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Konsultoinnin ja teknisen toteutuksen johtaminen terveydenhuollon, biotieteiden, rahoitusalan ja tekoälyn aloilla; oma käytännön toteutustyö yhdistettynä tiimin koordinointiin ja sidosryhmäviestintään.',
        'LLM-/RAG-infrastruktuurin ja MCP-pohjaisen työkaluintegraation suunnittelu. OpenCode-avusteisten R-/Python-työnkulkujen vakiinnuttaminen koodin generointiin, refaktorointiin, testaukseen ja dokumentointiin ihmisen tekemällä tarkastuksella.'
      ]
    },
    {
      period: 'Vuodesta 2022 alkaen',
      title: 'Syöpärekisteri ja biopankki, Medical University Pleven',
      description: [
        'Kansallisen syöpärekisterin datan analysointi ja Shiny-koontinäyttöjen rakentaminen kliinisille ja tutkimuksen sidosryhmille; integraation, dokumentoinnin ja biopankkityönkulkujen tuki viidessä syöpätyypissä.'
      ]
    },
    {
      period: 'Vuodesta 2025 alkaen',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Tuotantovalmiin R Shiny -sovelluksen rakentaminen; CSV-datan migraatio SQLiteen sekä ylläpitäjän todennus, instituutioiden hallinta, kävijäanalytiikka, maksulliset listaukset ja yhteydenottolomakkeet SMTP-ilmoituksineen.',
        'Responsiivisen käyttöliittymän ja käyttökokemuksen (UI/UX), hakukoneoptimoinnin (SEO), strukturoidun datan ja sitemap/robots-tuen parantaminen; syötteiden validointi, tulosteen escape-käsittely, kirjautumisyritysten rajoitus ja vain vahvistetut julkiset tietueet. Yli 400 instituution auditointi ELLIS-, CAIRNE-, AI NATION-, NET4AI-, INSAIT- ja AI-on-Demand-lähteiden avulla sekä alkuperän ja käyttöönoton/tietoturvan dokumentointi.'
      ]
    },
    {
      period: 'Vuodesta 2024 alkaen',
      title: 'LLM-pohjainen talousuutisten analytiikka, Leap Dynamics (sisäinen projekti)',
      description: [
        'Toistuvien sentimenttianalyysityönkulkujen rakentaminen: LLM-mallit, API-data, automatisoidut PDF-raportit, Streamlit-käyttöliittymä, n8n-orkestrointi ja Flowise-avusteinen työnkulkujen testaus.'
      ]
    },
    {
      period: '2025',
      title: 'Johtotason työpajat, BVMW',
      description: [
        'Työpajojen pitäminen toimitusjohtajatason osallistujille BVMW-verkostossa.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Tutkija, Humboldt-Universität / Charité, Berliini',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO ja yksi perustajista, Promethano GmbH',
      description: [
        'Ohjelmistoja ja aikasarjasovelluksia biotieteille.'
      ]
    }
  ]
};
